export enum AppDistributionType {
  Public = 'Public',
  L4B = 'L4B',
  Library = 'Library',
}
